import PropTypes from "prop-types";
import React, { useState } from "react";

const ChatMessage = ({ text, maxLength = 100 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Toggle between expanded and collapsed state
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    // Check if the text exceeds the maxLength
    const isLongText = text.length > maxLength;

    return (
        <div className="chat-message">
            <span>
                {isExpanded || !isLongText
                    ? text
                    : `${text?.slice(0, maxLength)}...`}
                {isLongText && (
                    <button onClick={toggleExpanded} className="show-more-btn mx-1">
                        {isExpanded ? "Show Less" : "Show More"}
                    </button>
                )}
            </span>

        </div>
    );
};

ChatMessage.propTypes = {
    text: PropTypes.shape({
        length: PropTypes.number,
        slice: PropTypes.func,
    }).isRequired,
    maxLength: PropTypes.number,
};

export default ChatMessage;
